<template>
  <nuxt-link
    :id="mobile ? 'mobile-orders-trigger' : 'orders-trigger'"
    class="btn-nav-orders"
    to="/accounts/orders/"
  >
    <template v-if="mobile">
      <img :src="mobileImageSrc" />
      <span>My Orders</span>
      <span v-if="pptoEligibleOrderCount" class="badge">{{
        pptoEligibleOrderCount
      }}</span>
    </template>
    <template v-else>
      <span v-if="pptoEligibleOrderCount" class="badge">{{
        pptoEligibleOrderCount
      }}</span>
      <span>My Orders</span>
    </template>
  </nuxt-link>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MyOrdersBell',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    mobileImageSrc: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['cart', 'pptoEligibleOrderCount']),
  },
  async beforeMount() {
    this.$store.dispatch('fetchPPTOEligibleOrderCount')
  },
}
</script>
